import { ChainId, ERC20Token, WETH9 } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  busd: new ERC20Token(
    ChainId.OPTIMISM,
    '0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  nmx: new ERC20Token(
    ChainId.OPTIMISM,
    '0x65830ac49aCE524A079417bA42F899F70363A8bf',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  usdc: new ERC20Token(ChainId.OPTIMISM, '0x7F5c764cBc14f9669B88837ca1490cCa17c31607', 6, 'USDC', 'USD Coin'),
  usdt: new ERC20Token(
    ChainId.OPTIMISM,
    '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
    6,
    'USDT',
    'Tether USD',
    'https://tether.to/',
  ),
  weth: WETH9[ChainId.OPTIMISM],
}
